import { render, staticRenderFns } from "./unbind-success.vue?vue&type=template&id=63e95965&lang=pug&"
import script from "./unbind-success.vue?vue&type=script&lang=js&"
export * from "./unbind-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports